"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tag = void 0;
var Tag = /** @class */ (function () {
    function Tag(options) {
        var _a;
        this.tagName = options.tagName;
        this.insertLineBreaks = options.insertLineBreaks;
        this.suppressLineBreaks = options.suppressLineBreaks;
        this.noNesting = options.noNesting;
        this.markupGenerator = (_a = options.markupGenerator) !== null && _a !== void 0 ? _a : (function (tag, content) { return "<" + tag.tagName + ">" + content + "</" + tag.tagName + ">"; });
    }
    Tag.create = function (tagName, markupGenerator, options) {
        var _a, _b, _c;
        if (options === void 0) { options = {}; }
        return new Tag({
            tagName: tagName,
            insertLineBreaks: (_a = options.insertLineBreaks) !== null && _a !== void 0 ? _a : true,
            suppressLineBreaks: (_b = options.suppressLineBreaks) !== null && _b !== void 0 ? _b : false,
            noNesting: (_c = options.noNesting) !== null && _c !== void 0 ? _c : false,
            markupGenerator: markupGenerator
        });
    };
    return Tag;
}());
exports.Tag = Tag;
